import { render, staticRenderFns } from "./ColorPaymentStatusFilter.vue?vue&type=template&id=2e0c810b&scoped=true"
import script from "./ColorPaymentStatusFilter.vue?vue&type=script&lang=js"
export * from "./ColorPaymentStatusFilter.vue?vue&type=script&lang=js"
import style0 from "./ColorPaymentStatusFilter.vue?vue&type=style&index=0&id=2e0c810b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0c810b",
  null
  
)

export default component.exports